import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Spinner } from '@/components/ui/Spinner'

/**
 * Page de retour après paiement Wave / Orange Money.
 * Le fournisseur redirige ici une fois le paiement terminé.
 * On lit le UUID du ticket depuis sessionStorage et on redirige vers la page ticket.
 */
export function PaymentReturnPage() {
  const navigate = useNavigate()

  useEffect(() => {
    const uuid = sessionStorage.getItem('pending_ticket_uuid')
    sessionStorage.removeItem('pending_ticket_uuid')

    if (uuid) {
      navigate(`/tickets/${uuid}?success=1`, { replace: true })
    } else {
      // Fallback : aucun UUID stocké (session expirée, autre onglet, etc.)
      navigate('/', { replace: true })
    }
  }, [navigate])

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center gap-4">
      <Spinner className="w-8 h-8 text-primary-600" />
      <p className="text-sm text-gray-500">Vérification du paiement en cours...</p>
    </div>
  )
}
